import React, { Component } from 'react'
import './footContent.less'
import wechat1 from '../../../../static/images/lingshou-1.png'
import wechat2 from '../../../../static/images/lingshou-2.png'
import wechat3 from '../../../../static/images/lingshou-3.png'
import wechat4 from '../../../../static/images/lingshou-4.png'
import { Tabs } from 'antd';
// const SubMenu = Menu.SubMenu;
const { TabPane } = Tabs;
class FootContent extends Component {
    
    state = {
        
    }


    componentDidMount(props) {
    }


    render() {
        
        return (
            <div className="foot-content-page">
                <div className="foot-top-content">
                    <div className="">开店就用专业软件，专业零售行业一体化解决方案</div>
                    <div className="try-btn">免费试用</div>
                </div>

                <div className="footer footer_1its">
                    <div className="container">
                        <div className="row footer-top mb-md-5 mb-4" style={{ marginBottom: '0!important' }}>
                            <div className="col-lg-4 col-md-6 footer-box-left aos-init aos-animate slide-text">
                                <div className="footer-title-w3ls">
                                    全国服务热线
                                </div>
                                <div className="footer-text">
                                    13063218899
                                </div>
                                <div className="row" style={{ marginLeft: 0, opacity: 0.6 }}>
                                    周一至周五 9:00-18:30
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className="footer-title-w3ls">
                                    专线响应更快
                                </div>
                                <div className="row" style={{ marginLeft: 0, opacity: 0.6 }}>
                                    合作咨询：13063218899
                                </div>
                                <div className="row" style={{ marginLeft: 0, opacity: 0.6 }}>
                                    技术支持：17154958941
                                </div>
                                
                            </div>
                            <div className="col-lg-4 col-md-6 slide-text-right">
                                <div className="footer-title-w3ls">
                                   关注我们
                                </div>
                                <div className="row  links-code">
                                    <Tabs className="col-12 links" tabPosition="left">
                                        <TabPane tab="官方微信" key="1">
                                            <div className="img-div">
                                                <img className="img-div-content" src={wechat2} alt="" />
                                            </div>
                                        </TabPane>
                                        <TabPane tab="官方抖音" key="2">
                                            <div className="img-div">
                                                <img className="img-div-content" src={wechat1} alt="" />
                                            </div>
                                        </TabPane>
                                        <TabPane tab="官方视频号" key="3">
                                            <div className="img-div">
                                                <img className="img-div-content" src={wechat3} alt="" />
                                            </div>
                                        </TabPane>
                                        <TabPane tab="官方小红书" key="4">
                                            <div className="img-div">
                                                <img className="img-div-content" src={wechat4} alt="" />
                                            </div>
                                        </TabPane>
                                    </Tabs>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="container-bottom">
                        <div className="foot-bottom-tips">
                            <span className="span">关于我们</span>
                            <span className="span span-block">|</span>
                            <span className="span">加入我们</span>
                            <span className="span span-block">|</span>
                            <span className="span">联系我们</span>
                        </div>
                        <div className="foot-bottom-tips">
                            <span className="span">北京悦喵数字科技有限公司</span>
                            <span className="span span-block"></span>
                            <span className="span">京ICP</span>
                            <span className="span-block"></span>
                            <span className="span">备2020049232号-2</span>
                        </div>
                    </div>
                </div>

                
               
            </div>
        )
    }
}

export default FootContent